export default "__VITE_ASSET__PmR$QHiw__"